import ACTIONS from '../actions';

export default function scansReducer(state, action) {
  switch(action.type) {
    case ACTIONS.GET_SCAN_FILES:
      return {
        ...state,
        scanFiles: action.payload
      };
    case ACTIONS.ADD_SCAN_FILE:
      return {
        ...state,
        scanFiles: [...state.scanFiles, ...action.payload]
      };
    default: 
      return state
  }
}
